import {
    SET_IS_CASSETTE_EJECTING,
    SET_IS_SCAN_CANCELLED,
    SET_IS_SCANNING
} from "../redux_constants/scanWorkflow.constant";

export const updateIsCassetteEjecting = (instance) => ({
    type: SET_IS_CASSETTE_EJECTING,
    response: instance,
})

export const updateIsScanCancelled = (instance) => ({
    type: SET_IS_SCAN_CANCELLED,
    response: instance,
})

export const updateIsScanningStarted = (instance) => ({
    type: SET_IS_SCANNING,
    response: instance,
})